import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import IconContainerRounded from './icon-container-rounded';
import { ButtonPrimary, colors, HSpacer } from '@aftersale-next/ui';

var ChannelOptionButton = function ChannelOptionButton(_ref) {
  var label = _ref.label,
      Icon = _ref.Icon,
      accent = _ref.accent,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonPrimary, {
      onClick: onClick,
      bgColor: colors.buttonForeground,
      textColor: colors.textForeground,
      transform: "capitalize",
      justify: "start",
      height: "56px",
      border: "1px solid ".concat(colors.divider),
      children: [/*#__PURE__*/_jsx(IconContainerRounded, {
        accent: accent,
        children: Icon
      }), label]
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "20px"
    })]
  });
};

export default ChannelOptionButton;